import {
  constants,
  getFromLocalStorage,
  setInLocalStorage,
} from 'app/utils/localStorage';
import React, { createContext, useEffect, useState } from 'react';

type DarkContextType = {
  darkMode: boolean;
  darkToggle: () => void;
};

const DarkModeContext = createContext<DarkContextType | null>(null);
const DarkModeContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element | null => {
  const [darkMode, setDarkMode] = useState<boolean>(false);
  const darkToggle = (mode?: boolean) => {
    if (mode !== undefined) {
      setDarkMode(mode);
    } else {
      setDarkMode(!darkMode);
      setInLocalStorage(constants.darkMode, !darkMode);
    }
  };
  useEffect(() => {
    const getDarkModeValue = getFromLocalStorage(constants.darkMode);
    if (typeof getDarkModeValue !== 'boolean') {
      setInLocalStorage(constants.darkMode, false);
    } else {
      setDarkMode(getDarkModeValue);
    }
  }, []);

  return (
    <div>
      <DarkModeContext.Provider value={{ darkMode, darkToggle }}>
        {children}
      </DarkModeContext.Provider>
    </div>
  );
};

export { DarkModeContextProvider, DarkModeContext };
